/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

import s from './styles.module.less';

const Item = ({ className, module, errors }) => {
  const { media } = useMedia(getImage(module.content));

  return (
    <div className={clsx(className, s.item)}>
      <InfoItem.WithError error={errors} size="large" image={media.src} description={module.content.title}>
        Useful Links
      </InfoItem.WithError>
    </div>
  );
};

export default Item;
